var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguagePythonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8288 3.44456C16.6413 3.45018 15.5079 3.55115 14.51 3.72778C11.571 4.24697 11.0377 5.33372 11.0377 7.33818V9.98503H17.9826V10.8673H8.43109C6.41284 10.8673 4.64546 12.0803 4.09253 14.3888C3.45465 17.034 3.42653 18.6849 4.09253 21.4471C4.58612 23.5033 5.76512 24.9681 7.78365 24.9681H10.1717V21.795C10.1717 19.5025 12.1548 17.4806 14.5103 17.4806H21.4473C23.3784 17.4806 24.9197 15.8904 24.9197 13.9515V7.33847C24.9197 5.45606 23.3317 4.04222 21.4473 3.72806C20.2537 3.5295 19.0159 3.43922 17.8288 3.44456ZM14.073 5.57334C14.7902 5.57334 15.3763 6.16875 15.3763 6.90112C15.3763 7.6304 14.7904 8.22018 14.073 8.22018C13.353 8.22018 12.7699 7.6304 12.7699 6.90112C12.7697 6.16875 13.353 5.57334 14.073 5.57334Z",
    fill: "url(#paint0_linear_88_1755)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7855 10.8675V13.9517C25.7855 16.3423 23.7583 18.3546 21.4469 18.3546H14.5099C12.6098 18.3546 11.0376 19.9811 11.0376 21.884V28.4976C11.0376 30.3795 12.6739 31.4867 14.5099 32.0265C16.7082 32.6725 18.8164 32.7895 21.4469 32.0265C23.1952 31.5199 24.9193 30.5013 24.9193 28.4976V25.8505H17.9825V24.9679H28.3921C30.4104 24.9679 31.163 23.5603 31.865 21.447C32.5901 19.2715 32.5588 17.1793 31.865 14.3887C31.3661 12.3792 30.4135 10.8672 28.3921 10.8672L25.7855 10.8675ZM21.8837 27.6151C22.604 27.6151 23.187 28.2048 23.187 28.9347C23.187 29.6665 22.6037 30.2619 21.8837 30.2619C21.1665 30.2619 20.5807 29.6665 20.5807 28.9347C20.5807 28.2048 21.1665 27.6151 21.8837 27.6151Z",
    fill: "url(#paint1_linear_88_1755)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.444,
    d: "M27.3681 33.6368C27.3681 34.6333 23.2011 35.4413 18.0613 35.4413C12.9212 35.4413 8.75415 34.6333 8.75415 33.6368C8.75415 32.6401 12.9209 31.832 18.0613 31.832C23.2011 31.832 27.3681 32.6398 27.3681 33.6368Z",
    fill: "url(#paint2_radial_88_1755)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_88_1755",
    x1: 2.9073,
    y1: 4.27217,
    x2: 18.9256,
    y2: 17.9325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A9FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#306998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_88_1755",
    x1: 24.9521,
    y1: 26.4241,
    x2: 19.2077,
    y2: 18.3685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE873"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_88_1755",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0237 33.5851) rotate(-90) scale(1.80515 7.93515)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8",
    stopOpacity: 0.498
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F7F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguagePythonIcon);
export default __webpack_public_path__ + "static/media/language_pythonIcon.2d501d2881be2d8b4c71664388875c1a.svg";
export { ForwardRef as ReactComponent };